import { render, staticRenderFns } from "./call-for-sponsors.vue?vue&type=template&id=2448dfd1&scoped=true&"
import script from "./call-for-sponsors.vue?vue&type=script&lang=js&"
export * from "./call-for-sponsors.vue?vue&type=script&lang=js&"
import style0 from "./call-for-sponsors.vue?vue&type=style&index=0&id=2448dfd1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2448dfd1",
  null
  
)

export default component.exports